<template>
  <div style="height:500px;">
    <el-scrollbar style="height:100%;">
      <div class="Details"
           v-loading="loading">
        <PlanCard v-for="item in PlanList"
                  :key="item.ID"
                  @refershSource="initalTask"
                  :item="item">

        </PlanCard>
        <!-- <div v-for="item in PlanList" :key="item.ID" @click="onFocus(item)">
          <el-row>
            <el-col :class="{focus:isFocus(item)}" :span="24">
              <div class="grid-content bg-purple-dark">
                <el-row>
                  <el-col :span="4">
                    <div class="title">编号</div>
                  </el-col>
                  <el-col :span="20">
                    <div class="code" @click="onRecord(item)">
                      {{item.ID}}
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="title">标题</div>
                  </el-col>
                  <el-col :span="20">
                    <div class="tagtitle">{{item.NAME}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="title">计划时间</div>
                  </el-col>
                  <el-col :span="20">
                    <div
                      class="tagtitle"
                    >{{item.BEGINTIME|timeFormater}}至{{item.ENDTIME|timeFormater}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="title">工时</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="tagtitle">{{item.PLANTIME}}{{item.PLANTIMEUNIT |UNITFilters}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="title">执行人</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="tagtitle">{{item.EXCUTEUSERNAME}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="title">进度</div>
                  </el-col>
                  <el-col :span="20">
                    <el-progress :percentage="item.PROCESS"></el-progress>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="title">计划内容</div>
                  </el-col>
                  <el-col :span="20">
                    <div class="tagtitle1" v-html="item.MEMO"></div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <div class="title">完成情况</div>
                  </el-col>
                  <el-col :span="20">
                    <div class="tagtitle1" v-html="item.COMPLETEINFO"></div>
                  </el-col>
                </el-row>
                <el-row v-if="compareDate(item.ENDTIME)">
                  <el-col :span="4">
                    <div class="title">延时工时</div>
                  </el-col>
                  <el-col :span="20">
                    <div>{{item.PLANTIMEUNIT}}{{item.DELAYUNITNAME |UNITFilters}}</div>
                    <div class="state" @click="onDelay(item)">延期</div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div> -->
        <div class="button">
          <el-button type="primary"
                     class="add"
                     @click="showDialog"
                     icon="el-icon-circle-plus-outline">新增任务计划</el-button>
          <!-- <el-button type="danger"
                     class="delete"
                     @click="onDelete"
                     size="mini">删除任务计划</el-button> -->
        </div>
      </div>
    </el-scrollbar>
    <SideTagsAddPlan ref="sideTagsAddPlan"
                     :mainId="task.ID"
                     @successed="initalTask"></SideTagsAddPlan>
  </div>
</template>

<script>
import PlanCard from "./PlanCard";
import { getToken } from "@/util/auth";
import SideTagsAddPlan from "./SideTagsAddPlan";
import { GetWorkPlanByTaskId, DelWorkPlan } from "@/api/modules/basicData/task";
const user = getToken();
const date = new Date();
export default {
  components: {
    SideTagsAddPlan,
    PlanCard
  },
  props: {
    task: {
      type: Object
    }
  },
  data() {
    return {
      PlanList: [],
      planId: "", //选中值ID
      planrow: {}, //选中值
      checked: true,
      per: 60,
      timetype: "1",
      loading: false,
      value7: ""
    };
  },
  methods: {
    showDialog: function() {
      this.$refs.sideTagsAddPlan.showDialog();
    },
    initalTask: function() {
      if (!this.task) return;
      this.loading = true;
      GetWorkPlanByTaskId(this.task.ID, 0).then(data => {
        if (!data) return;
        console.log("initalTask", data);
        this.PlanList = data;
        this.loading = false;
      });
    },
    compareDate: function(date1) {
      var Date1 = new Date(date1);
      var Date2 = new Date();
      if (Date1 >= Date2) {
        return false;
      } else {
        return true;
      }
    },
    onFocus: function(row) {
      this.planId = row.ID;
      this.planrow = row;
    },
    isFocus: function(row) {
      if (row.ID == this.planId) return true;
      else return false;
    },
    onDelete: function() {
      if (!this.planId) return;
      let paras = {
        PlanId: this.planId,
        Person: {
          ID: user.userId,
          NAME: user.realName,
          DEPTID: user.departmentId,
          DEPTNAME: user.departmentName,
          COMPANYID: user.organizationId,
          COMPANYNAME: user.organizationName
        }
      };
      DelWorkPlan(paras).then(pmevent => {
        console.log(pmevent);
        if (pmevent.ResultCode === 1) {
          this.initalTask();
          this.$message({
            type: "success",
            message: "删除工作记录成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "删除工作记录失败！"
          });
        }
      });
    }
  },
  computed: {
    tabIndex: function() {
      return this.$store.state.task.tabIndex;
    }
  },
  filters: {
    UNITFilters: function(val) {
      switch (val) {
        case 0:
          return "小时";
        case 1:
          return "天";
        case 2:
          return "周";
        case 3:
          return "月";
        case 4:
          return "季";
        default:
          return "";
      }
    }
  },
  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    },
    tabIndex: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    }
  }
};
</script>

<style scoped>
.Details .el-row {
  padding: 20px 20px 0 20px;
}
.grid-content .el-row {
  padding: 5px 20px 0 20px;
}
.el-col {
  border-radius: 4px;
  text-align: left;
}
.button {
  margin: 10px;
  float: left;
}
.button .add {
  background: #ecf5ff;
  color: #0099ff;
}
.button .delete {
  background: #f9ebed;
  color: #f02d52;
  border: solid 1px #f02d52;
}
.bg-purple-dark {
  background: white;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.Details {
  background-color: #f3f3f3;
  min-height: 500px;
}
.title {
  text-align: left;
  font-family: MicrosoftYaHei-Bold;
  font-size: 12px;
  font-weight: 800;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #5b6379;
}
.abstract {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0px;
  font-family: MicrosoftYaHei;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #909399;
}
.tagtitle {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #858585;
}
.tagtitle1 {
  font-size: 12px;
  color: #f56c6c;
}
.tagtitle1 p {
  margin-top: 5px;
  margin-bottom: 5px;
}
.state {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  background-color: #fff6ec;
  width: 30px;
  height: 17px;
  color: #ffa140;
  border-radius: 4px;
  padding: 5px 13px 5px 12px;
  border: 1px solid #ffa140;
  float: right;
  margin-bottom: 15px;
  cursor: pointer;
}
.focus {
  box-shadow: #5cbeff 0 0 18px !important;
}
.code {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #0099ff;
  cursor: pointer;
}
</style>